export default __webpack_public_path__ + "static/media/knowledge_page_icon.99cf1e09.svg";